import { Koi } from '@ksyos/koi';
import type { TypedSchema } from '@common/validation/utils/typedSchemaType';
import { addAllowNull } from '@common/validation/utils/addAllowNull';
import { getTextInputStringSchema } from '@common/validation/utils/getTextInputStringSchema';

export interface ITpcFlexRequestData {
    question: string | null;
}

const tpcFlexRequestFinal: TypedSchema<ITpcFlexRequestData> = {
    question: getTextInputStringSchema(),
};

const tpcFlexRequestDraft: TypedSchema<ITpcFlexRequestData> = addAllowNull(tpcFlexRequestFinal);

export const tpcFlexRequestDraftSchema = Koi.object(tpcFlexRequestDraft);
export const tpcFlexRequestFinalSchema = Koi.object(tpcFlexRequestFinal);
